/**
 * @module ol/geom/GeometryLayout
 */
/**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */
export default {
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM',
};
//# sourceMappingURL=GeometryLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/geom/GeometryLayout.js
// module id = 98
// module chunks = 8